<template>
	<div class="conversation">
		<ConversationHistory
			@update:scrolledToBottom="updateHistoryScrolledToBottom($event)"
		/>
		<div
			v-if="historyScrolledToBottom && curTyping.length > 0"
			class="typing-indicator"
		>
			<div class="typing-avatars">
				<UserAvatar
					v-for="typer in curTyping"
					:providerName="curConversation.providerName"
					:userId="typer.userId"
					class="rounded flat"
					:key="typer.userId"
				/>
			</div>
			<span class="typing-ids">
				<span
					v-for="(typer, index) in curTypingShortened"
					class="typer-id"
					:key="typeof typer === 'string' ? typer : typer.userId"
				>
					<span v-if="typeof typer === 'string'"
						>{{ typer }} more</span
					>
					<span v-else>
						{{
							typer.hasOwnProperty('userName')
								? typer.userName
								: typer.userId
						}}{{
							curTyping.length > 1 &&
							index === curTyping.length - 2
								? '&nbsp;and&nbsp;'
								: index !== curTyping.length - 1
								? ',&nbsp;'
								: ''
						}}
					</span> </span
				><i
					>&nbsp;{{ curTyping.length === 1 ? 'is' : 'are' }} typing
					...</i
				>
			</span>
		</div>
		<Actionbar :historyScrolledToBottom="historyScrolledToBottom" />
	</div>
</template>

<script>
import ConversationHistory from './ConversationHistory.vue';
import UserAvatar from './UserAvatar.vue';
import Actionbar from './Actionbar.vue';
import { mapGetters } from 'vuex';

export default {
	name: 'Conversation',
	components: {
		ConversationHistory,
		UserAvatar,
		Actionbar
	},
	data() {
		return {
			historyScrolledToBottom: true
		};
	},
	computed: {
		curTyping() {
			let gCT = this.$store.getters[
				'ConversationProviders/provider_' +
					this.curConversation.providerName +
					'/getCurTyping'
			];
			if (gCT) {
				let arr = gCT(this.curConversation.conversationId);
				if (
					arr &&
					typeof arr === 'object' &&
					arr.hasOwnProperty('length') &&
					typeof arr.length === 'number' &&
					arr.length > 0
				) {
					arr = JSON.parse(JSON.stringify(arr));
					for (let i = 0; i < arr.length; i++) {
						let u = arr[i];
						if (u.userId === this.getCurConversationUser.userId) {
							arr.splice(i, 1);
							break;
						}
					}
					return arr;
				}
			}
			return [];
		},
		curTypingShortened() {
			let shortened = this.curTyping.slice(0, 5);

			if (this.curTyping.length > 5) {
				shortened.push((this.curTyping.length - 5).toString());
			}

			return shortened;
		},
		...mapGetters({
			curConversation: 'curConversation',
			getCurConversationUser:
				'ConversationProviders/getCurConversationUser'
		})
	},
	methods: {
		updateHistoryScrolledToBottom(to = true) {
			this.historyScrolledToBottom = !!to;
		}
	}
};
</script>
